import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OrderDialogItem, OrderheadService } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-orderhead-dialog',
    templateUrl: './orderhead-dialog.component.html',
    styleUrls: ['./orderhead-dialog.component.css'],
})
export class OrderheadDialogComponent implements OnChanges {
    @Input()
    public orderInternalNo?: string;

    @Input()
    public dialog: OrderDialogItem[] = [];

    @Input()
    public set dialogAsInput(value: BooleanInput) {
        this._dialogAsInput = coerceBooleanProperty(value);
    }
    public get dialogAsInput(): boolean {
        return this._dialogAsInput;
    }
    private _dialogAsInput = false;

    @Output() // The kendo-editor is very slow, and so it cannot be used in javascript component, so while the orderhead page component is written in js it needs to use the js modal component, thus an event is emitted.
    public openDialog = new EventEmitter<OrderDialogEvent>();

    constructor(private orderhead: OrderheadService) {}

    public trackBy = (_: number, item: OrderDialogItem) => {
        return item.reg_datetime + item.registered_by_name;
    };

    public async openDialogDialog() {
        const event: OrderDialogEvent = {
            preventingDefault: false,
            preventDefault: function () {
                this.preventingDefault = true;
            },
        };

        this.openDialog.emit(event);

        if (event.preventingDefault) return;

        if (!!this.orderInternalNo) {
            await this.orderhead.openOrderDialogDialog({ order_internal_no: this.orderInternalNo });
            this.loadOrderDialog();
        }
    }

    private async loadOrderDialog() {
        if (!!this.orderInternalNo) {
            this.dialog = await this.orderhead.getOrderDialog({ order_internal_no: this.orderInternalNo });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dialogAsInput']) {
            this.dialogAsInput = changes['dialogAsInput'].currentValue;
        }

        console.log(this.dialogAsInput);
        if (changes['orderInternalNo'] && !this.dialogAsInput) {
            this.loadOrderDialog();
        }
    }
}

export interface OrderDialogEvent {
    preventDefault(): void;
    preventingDefault: boolean;
}
